import { createMutateReducer } from "common/helpers/reducer";
import * as action from "../actions/cpKkmAddAction";

const initialState = {
	isLoading: true,
	isLoadingSend: false,

	formState: {}
};
const actionHandlers = {
	// Initialize
	[action.initCpKkmAdd.request]: createMutateReducer(draft => {
		draft.isLoading = true;
	}),
	[action.initCpKkmAdd.success]: createMutateReducer((draft, { formState }) => {
		draft.isLoading = false;
		draft.formState = formState;
	}),
	[action.initCpKkmAdd.error]: createMutateReducer(draft => {
		draft.isLoading = false;
	})
};

export { initialState, actionHandlers };
export default createReducer => createReducer(initialState, actionHandlers);
